import { space, colors } from 'nicollet-tokens';
import styled from 'styled-components';
import { IconNavigationCloseCircle } from 'nicollet-icons-react';
import { BaseIconButton } from '../BaseIconButton/index.js';

const StyledBaseIconButton = styled(BaseIconButton)`
  padding: ${space.generic.x4};
  &:focus {
    outline-offset: -10px;
  }
`;
const StyledIconCloseCircle = styled(IconNavigationCloseCircle)`
  path:first-child {
    transition: 100ms;
  }
  :hover path:first-child {
    fill: ${colors.link.onDark.hover};
  }
  :active path:first-child {
    fill: ${colors.link.onLight.focus};
  }
  :active path:nth-child(2) {
    fill: ${colors.link.onDark.default};
  }
`;

export { StyledBaseIconButton, StyledIconCloseCircle };
